export default __webpack_public_path__ + "static/media/NTEX CLASS-10_SYLLABUS_2025-26.a46aef3c.pdf";